
const AdminUsers=()=>{
    const UserList:number[]=[
        1,3,
    ]
    return UserList;
}

export default AdminUsers;